import React from "react";
import classnames from "classnames";
import { formatFileSize } from "@dhn/shared/utils/file-size";

export const MAX_TOTAL_FILE_SIZE_MB = 8;
export const MAX_TOTAL_FILE_SIZE_BYTES =
  MAX_TOTAL_FILE_SIZE_MB * 1024 * 1024;

const DEFAULT_DESCRIPTION = (maxSizeLabel) =>
  `PDF, JPG o PNG. La suma de todos los archivos, incluida la evidencia de especialidad, debe ser menor de ${maxSizeLabel}.`;

export default function DocumentsSizeProgress({
  className,
  description,
  title = "Peso total de todos los archivos",
  totalSize = 0,
  maxSizeBytes = MAX_TOTAL_FILE_SIZE_BYTES,
  maxSizeLabel = `${MAX_TOTAL_FILE_SIZE_MB} MB`,
}) {
  const normalizedTotalSize = Math.max(0, Number(totalSize || 0));
  const percentage = Math.min(
    100,
    (normalizedTotalSize / maxSizeBytes) * 100,
  );
  const sizeLabel = `${formatFileSize(normalizedTotalSize, { empty: "0 KB" })} de ${maxSizeLabel}`;

  return (
    <div className={classnames("documents-size-progress", className)}>
      <div className="d-flex justify-content-between flex-wrap mb-2">
        <strong>{title}</strong>
        <span aria-live="polite" aria-atomic="true">
          {sizeLabel}
        </span>
      </div>
      <div
        className="documents-size-track"
        role="progressbar"
        aria-label="Espacio ocupado por todos los archivos"
        aria-valuemin={0}
        aria-valuemax={maxSizeBytes}
        aria-valuenow={normalizedTotalSize}
        aria-valuetext={sizeLabel}
      >
        <div
          className="documents-size-fill"
          style={{ width: `${percentage}%` }}
        />
      </div>
      {description !== null && (
        <small className="d-block mt-2">
          {description || DEFAULT_DESCRIPTION(maxSizeLabel)}
        </small>
      )}
    </div>
  );
}
